import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=0a5fc1d4&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=0a5fc1d4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5fc1d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a5fc1d4')) {
      api.createRecord('0a5fc1d4', component.options)
    } else {
      api.reload('0a5fc1d4', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=0a5fc1d4&scoped=true", function () {
      api.rerender('0a5fc1d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/airTransport/airlinePushRecords/cmp/detail.vue"
export default component.exports